import { render, staticRenderFns } from "./IncomeCalculator.vue?vue&type=template&id=4dc90998&scoped=true&"
import script from "./IncomeCalculator.vue?vue&type=script&lang=js&"
export * from "./IncomeCalculator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc90998",
  null
  
)

export default component.exports